module.exports = __webpack_public_path__ + "static/media/accessory__vibrationSensor.2a0d08b1.jpg";